import React, { useState, useContext, useMemo }from 'react';
import { Route, Redirect, useHistory, useLocation } from 'react-router-dom';
import Sidebar from '../../components/sidebar/Sidebar';
import Topbar from '../../components/topbar/Topbar';
import './UserRoute.css'

// import { useToken, useUserPermission } from "../context/useToken";
import { useToken, useUserInfo } from '../../context/TokenContext';
import { UserContext } from '../../context/UserContext';
import { UserTokenContext, UserPermissionContext } from '../../context/TokenContext';




const UserRoute = ({component: Component, ...rest}) => {
    const {token, setToken} = useToken();
    let location = useLocation();
    const {userPermission, user} = useUserInfo();
    // console.log(userPermission, 'in user route');
    // console.log(token, 'in user route');

    const allUserPermissions = new Set(['user', 'admin']);
    // const topBar = useMemo(
    //     () => <Topbar user={user} setToken={setToken} />,
    //     [user, setToken]
    // );
    // console.log(location, !userPermission, !allUserPermissions.has(userPermission))
    if(!userPermission || !allUserPermissions.has(userPermission)) {
        // history.push('/login');
        return <Redirect to='/login' state ={{from : location}}/>;
    }
    // console.log(user, token);

    return (
        <Route {...rest} 
        component = {props => {
            return (
                <div>
                    <Topbar user={user} setToken={setToken} />
                    <div className="adminContainer">
                        {/* <Sidebar /> */}
                        <Component {...props} token={token}/>
                    </div>
                </div>
            )
        }}
        />
    );
};



export default UserRoute;